import React from 'react'
import moment from 'moment';
import { GlobalOutlined } from '@ant-design/icons';
import { Footer as AntFooter } from 'antd/es/layout/layout';

export default function Footer() {
    return (
        <AntFooter>
            <p className="left">Copyright © {moment().format('YYYY')} WLA. All rights reserved.</p>
            <div className="right">

               <a href='https://marametro.com' target='_blank' rel="noreferrer">
                    <GlobalOutlined /> WLA.com
                </a>
              
            </div>
        </AntFooter>
    )
}
